import { NavLink } from 'react-router-dom';
import { FiHome, FiCheckSquare, FiBarChart2, FiMessageSquare, FiSettings } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

export const BottomNav = () => {
  const { user } = useAuth();

  // Level 1, 2는 관리자 메뉴 표시
  const isAdmin = user && user.level <= 2;

  return (
    <nav className="bottom-nav">
      <NavLink
        to="/"
        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
      >
        <span className="nav-icon"><FiHome /></span>
        <span>객실선택</span>
      </NavLink>

      <NavLink
        to="/my"
        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
      >
        <span className="nav-icon"><FiCheckSquare /></span>
        <span>내청소</span>
      </NavLink>

      {isAdmin && (
        <NavLink
          to="/admin"
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="nav-icon"><FiBarChart2 /></span>
          <span>현황</span>
        </NavLink>
      )}

      {isAdmin && (
        <NavLink
          to="/memo"
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          <span className="nav-icon"><FiMessageSquare /></span>
          <span>메모</span>
        </NavLink>
      )}

      <NavLink
        to="/settings"
        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
      >
        <span className="nav-icon"><FiSettings /></span>
        <span>설정</span>
      </NavLink>
    </nav>
  );
};
